import { FunctionComponent, useEffect, useState } from 'react';
import TextInputField from '../../Components/TextInput/TextInputField';
import { FormikProps, useFormik } from 'formik';
import * as Yup from 'yup';
import {
  addDesignation,
  clearAddDesignationState,
} from '../../Redux/Slicers/Designation/AddDesignationSlicer';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import {
  clearUpdateDesignationState,
  updateDesignation,
} from '../../Redux/Slicers/Designation/UpdateDesignationSlicer';
import { getMaster } from '../../Redux/Slicers/Master/MasterSlicer';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useLocation } from 'react-router-dom';
import Select from '../../Components/Select/Select';
import { Checkbox, FormControlLabel } from '@mui/material';
import { WorkingHoursMap } from './IDesignation';

interface DesignationFormProps {
  designationForm: (data: FormikProps<any>) => void;
}

const DesignationForm: FunctionComponent<DesignationFormProps> = (props) => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(getMaster(null));
  }, []);

  const { pathname } = location;
  const pathnameParts = location.pathname.split("/");
  const id1 = pathnameParts[pathnameParts.length - 1];
  const [selectedUsers, setSelectedUsers] = useState<any[]>([]);
  const [showWorkingTime, setShowWorkingTime] = useState(false);

  const { updateableDate } = useAppSelector((state) => state.UpdateDesignation);
  const { data: master } = useAppSelector((state) => state.Master);

  const defaultWorkingHours: WorkingHoursMap = {
    sun: { open: false, start: '', end: '' },
    mon: { open: false, start: '', end: '' },
    tues: { open: false, start: '', end: '' },
    wed: { open: false, start: '', end: '' },
    thurs: { open: false, start: '', end: '' },
    fri: { open: false, start: '', end: '' },
    sat: { open: false, start: '', end: '' },
  };

  const formik = useFormik({
    initialValues: {
      name: '',
      // user_id: [],
      membershipType: 'OTHERS',
      working_hours: defaultWorkingHours,
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required('Please enter Name'),
      // membershipType: Yup.string().required("Please choose type"),
    }),
    onSubmit: (value) => {
      if (updateableDate && Object.keys(updateableDate).length !== 0) {
        dispatch(updateDesignation({ ...value, id: updateableDate._id }));
      } else {
        const dd = { ...value, location_id: id1 };
        dispatch(addDesignation(dd));
      }
    },
  });

  useEffect(() => {
    props.designationForm(formik);
    if (updateableDate) {
      console.log('updateableDate', updateableDate);

      formik.setFieldValue('name', updateableDate.name);
      formik.setFieldValue(
        'working_hours',
        updateableDate.working_hours || defaultWorkingHours
      );

      // formik.setFieldValue("membershipType", updateableDate.designation_type);

      // const userIds = updateableDate.user_id
      //   .map((userId: string) => {
      //     const user = master?.response?.data?.find(
      //       (u: any) => u._id === userId
      //     );

      //     return user
      //       ? { label: `${user.first_name}_${user.phone}`, value: user._id }
      //       : null;
      //   })
      //   .filter(Boolean); // Remove null values

      // formik.setFieldValue(
      //   "user_id",
      //   userIds.map((user: any) => user.value)
      // );
      // setSelectedUsers(userIds);
    }

    const hasWorkingTime = Boolean(
      updateableDate?.working_hours &&
        Object.values(updateableDate.working_hours).some(
          (time: any) => Boolean(time?.open || time?.start || time?.end)
        )
    );
    setShowWorkingTime(hasWorkingTime);

    return () => {
      dispatch(clearAddDesignationState());
      dispatch(clearUpdateDesignationState());
      formik.resetForm();
    };
  }, [updateableDate]);

  const renderWorkingHoursFields = (day: keyof WorkingHoursMap) => {
    const workingHours = formik.values.working_hours || defaultWorkingHours;
    const dayKey = day as string;
    const dayHours = workingHours[day];

    return (
      <div style={{ display: 'flex', columnGap: '10px' }}>
        <Select
          sx={{ width: '50%' }}
          id={`working_hours.${dayKey}.open`}
          name={`working_hours.${dayKey}.open`}
          label={`${dayKey.charAt(0).toUpperCase() + dayKey.slice(1)} Status`}
          value={dayHours.open ? 'Active' : 'Deactive'}
          options={['Active', 'Deactive']}
          onChange={(_, value) => {
            formik.setFieldValue(
              `working_hours.${dayKey}.open`,
              value === 'Active'
            );
          }}
          onBlur={formik.handleBlur}
          placeholder="-select-"
        />
        {dayHours.open && (
          <>
            <TextInputField
              sx={{ width: '25%' }}
              id={`working_hours.${dayKey}.start`}
              name={`working_hours.${dayKey}.start`}
              label={`${dayKey.charAt(0).toUpperCase() + dayKey.slice(1)} Start Time`}
              value={dayHours.start}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="00:00"
            />
            <TextInputField
              sx={{ width: '25%' }}
              id={`working_hours.${dayKey}.end`}
              name={`working_hours.${dayKey}.end`}
              label={`${dayKey.charAt(0).toUpperCase() + dayKey.slice(1)} End Time`}
              value={dayHours.end}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="00:00"
            />
          </>
        )}
      </div>
    );
  };

  // Filter options for users not already selected
  // const userOptions =
  //   master?.response?.data
  //     ?.map((user: any) => ({
  //       label: user.first_name + '_' + user.phone,
  //       value: user._id,
  //     }))
  //     .filter(
  //       (userOption) =>
  //         !selectedUsers.some((selected) => selected?.value === userOption.value)
  //     ) || [];

  const membershipTypes = [
    // { key: "Monthly membership", value: "MONTMEM" },
    // { key: "Cancel membership", value: "CANCELMEM" },
    { key: "Others", value: "OTHERS" },
  ];
  const selectedMembershipType =
    membershipTypes.find(
      (item) => item.value === formik.values.membershipType
    ) || null;

  console.log('Selected membership type:', formik.values);
  return (
    <form
      className="master_form"
      onSubmit={formik.handleSubmit}
      onReset={formik.handleReset}
      autoComplete="off">
      <TextInputField
        id="name"
        name="name"
        label="Name"
        value={formik.values.name}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        helperText={formik.touched.name && formik.errors.name}
        error={formik.touched.name && Boolean(formik.errors.name)}
      />

      {/* <Select
        id="membershipType"
        name="membershipType"
        label="Membership Type"
        // value={
        //   selectedMembershipType
        //     ? {
        //         label: selectedMembershipType.key,
        //         value: selectedMembershipType.value,
        //       }
        //     : null
        // }
        value={{ label: "Others", value: "OTHERS" }}
        options={membershipTypes.map((item) => ({
          label: item.key,
          value: item.value,
        }))}
        onChange={(_, value: any) => {
          formik.setFieldValue("membershipType", value ? value.value : null);
        }}
        onBlur={formik.handleBlur}
        helperText={
          formik.touched.membershipType && formik.errors.membershipType
        }
        error={
          formik.touched.membershipType && Boolean(formik.errors.membershipType)
        }
        placeholder="-select-"
      /> */}

      {/* <Autocomplete
        multiple
        options={userOptions}
        getOptionLabel={(option) => option.label}
        value={selectedUsers}
        onChange={(event, newValue) => {
          const selectedIds = newValue.map((option) => option.value);
          formik.setFieldValue('user_id', selectedIds);
          setSelectedUsers(newValue);
        }}
        filterOptions={(options, state) => {
          const filteredOptions = options.filter((option) =>
            option.label.toLowerCase().includes(state.inputValue.toLowerCase())
          );
          return filteredOptions.length ? filteredOptions : [];
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Add user to designation"
            placeholder="Select user to designation"
            error={formik.touched.user_id && Boolean(formik.errors.user_id)}
            helperText={formik.touched.user_id && formik.errors.user_id}
          />
        )}
      /> */}
      <div style={{ width: '100%', marginTop: 16 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={showWorkingTime}
              onChange={(event) => {
                setShowWorkingTime(event.target.checked);
                if (!event.target.checked) {
                  formik.setFieldValue('working_hours', defaultWorkingHours);
                }
              }}
            />
          }
          label="Working Time"
        />
        {showWorkingTime &&
          Object.keys(formik.values.working_hours || defaultWorkingHours).map(
            (day) => (
              <div style={{ width: '100%', marginTop: 8 }} key={day}>
                {renderWorkingHoursFields(day as keyof WorkingHoursMap)}
              </div>
            )
          )}
      </div>
      <button
        type="submit"
        style={{ display: 'none' }}
      />
    </form>
  );
};

export default DesignationForm;
